import { NumberInput, Select, TextInput } from "@mantine/core";
import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import styled from "styled-components";

function ObjectAddEditForm(props) {
  const { fields, onSubmit, submitButton, defaultValues, page } = props;

  const {
    control,
    handleSubmit,
    getValues,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues,
  });

  useEffect(() => {
    reset(defaultValues);
  }, [defaultValues, reset]);

  const validateInput = (value) => {
    const inputRegex = /.+/;
    if (typeof value === "undefined" || !inputRegex.test(value)) {
      return "Text를 입력해주세요.";
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <S.FormWrap>
          {fields?.map((field, index) => {
            const {
              key,
              name,
              type,
              options,
              component: Component,
              disabled,
              defaultValue,
              show,
              min,
              max,
            } = field;
            return (
              <>
                {show !== false && (
                  <div key={index}>
                    {type === "text" && (
                      <Controller
                        control={control}
                        name={key}
                        rules={options === "validate" && { validate: validateInput }}
                        defaultValue={defaultValue}
                        render={({ field }) => (
                          <TextInput
                            label={name}
                            error={errors[key]?.message}
                            disabled={disabled}
                            required={options === "validate"}
                            defaultValue={defaultValue}
                            {...field}
                          />
                        )}
                      />
                    )}
                    {type === "number" && (
                      <Controller
                        control={control}
                        name={key}
                        rules={options === "validate" && { validate: validateInput }}
                        defaultValue={defaultValue} 
                        render={({ field  }) => (    
                          <NumberInput                   
                            label={name}
                            error={errors[key]?.message}
                            disabled={disabled}
                            required={options === "validate"}
                            defaultValue={defaultValue}
                            min={min ? min : 1}   // bjkim6114
                            max={max ?? max}      // bjkim6114
                            {...field}
                          />
                        )}
                      />
                    )}
                    {type === "select" && (
                      <Controller
                        control={control}
                        name={key}
                        defaultValue={defaultValue}
                        render={({ field }) => {
                          return (
                            <Select
                              placeholder={`${name}을 골라주세요.`}
                              label={name}
                              error={errors[key]?.message}
                              data={options}
                              disabled={disabled}
                              value={field.value}
                              {...field}
                            />
                          );
                        }}
                      />
                    )}
                    {type === "etc" && (
                      <Controller
                        control={control}
                        name={key}
                        defaultValue={defaultValue}
                        rules={options === "validate" && { validate: validateInput }}
                        render={({ field }) => {
                          return (
                            <Component
                              name={name}
                              field={field}
                              onChange={(event) => field.onChange(event)}
                              defaultValue={defaultValue}
                              disabled={disabled}
                            />
                          );
                        }}
                      />
                    )}
                  </div>
                )}
              </>
            );
          })}
        </S.FormWrap>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-end",
          }}
        >
          {submitButton}
        </div>
      </form>
    </div>
  );
}

export default ObjectAddEditForm;

const S = {
  FormWrap: styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  `,
};
